module.exports = __webpack_public_path__ + "static/media/WeeklyProgressEmptyState.22f486b6.svg";